import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    loginInfo: null,
    goingToUrl: ''
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
